import { OperatorType } from './types/Operator';

export const ALL_OPERATORS = Object.values(OperatorType);

export const DEFAULT_VALIDATION_SEPARATOR = ',';

/**
 * Разделитель по умолчанию: пробел, запятая или точка с запятой.
 */
export const DEFAULT_SPLITTER = /[ \t]*[, ;][ \t]*/;

/**
 * Разделитель для вставки из Excel: запятая, точка с запятой или перенос строки.
 */
export const EXCEL_PASTE_SPLITTER = /[,;\r\n]+/;
